import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { keyCodes } from '@constants/keyboard/keyboard-constans';
import { Accordion } from '../../common/accordion/accordion';
import ModalDatiPersonali from './modal';
import PLUS from '@svg/plus.svg';
import CROSS from '@svg/cross.svg';

export default function SegnalazioniAccordions() {
  const [open, setOpen] = useState({
    firstAccordion: false,
    secondAccordion: false,
    thirdAccordion: false,
    fourthAccordion: false,
    fifthAccordion: false,
    sixthAccordion: false,
    seventhAccordion: false
  });

  const intl = useIntl();

  const [openModal, setOpenModal] = useState(false);

  return (
    <div
      className="snf-lx-components-segnalazioni-accordions-accordions"
      style={{ display: 'contents' }}
    >
      <div className="row m-0 wrapper w-100">
        <div className="col-12 col-md-10 offset-md-1">
          <div className="row">
            <div className="col-12 mb-4">
              <Accordion
                head={intl.formatMessage({
                  defaultMessage: 'Chi può contattare il canale di segnalazione?'
                })}
                open={open.firstAccordion}
                Icon={open.firstAccordion ? CROSS : PLUS}
                iconColor="#1576b0"
                setOpen={(state) => setOpen({ ...open, firstAccordion: state })}
              >
                <div>
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        '<p>Ai sensi dell’art. 3 del Decreto Legislativo 10 marzo 2023, puoi utilizzare questo canale se sei:</p>' +
                        '<ol>' +
                        '<li>un nostro lavoratore dipendente (in tal caso hai a disposizione anche altri canali dedicati);</li>' +
                        '<li>un candidato all’assunzione;</li>' +
                        '<li>un lavoratore autonomo, oppure un titolare di un rapporto di collaborazione coordinata e continuativa;</li>' +
                        '<li>un lavoratore o collaboratore, che svolge la propria attività lavorativa presso soggetti del settore pubblico o del settore privato, che forniscono beni o servizi o che realizzano opere in favore di terzi;</li>' +
                        '<li>un libero professionista o un consulente;</li>' +
                        '<li>un volontario o un tirocinante, retribuito e non retribuito;</li>' +
                        '<li>un azionista o una persona con funzioni di amministrazione, direzione, controllo, vigilanza o rappresentanza, anche qualora tali funzioni siano esercitate in via di mero fatto.</li>' +
                        '</ol>'
                    },
                    {
                      p: (chunks) => <p>{chunks}</p>,
                      ol: (chunks) => <ol className="ordered-roman">{chunks}</ol>,
                      li: (chunks) => <li>{chunks}</li>
                    }
                  )}
                </div>
              </Accordion>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-4">
              <Accordion
                head={intl.formatMessage({
                  defaultMessage: 'Quali segnalazioni puoi effettuare?'
                })}
                open={open.secondAccordion}
                Icon={open.secondAccordion ? CROSS : PLUS}
                iconColor="#1576b0"
                setOpen={(state) => setOpen({ ...open, secondAccordion: state })}
              >
                {intl.formatMessage(
                  {
                    defaultMessage:
                      '<p>Se rientri nelle categorie sopra citate, puoi effettuare le segnalazioni relative a:</p>' +
                      '<ol>' +
                      "<li>illeciti relativi all'applicazione degli atti nazionali o dell’Unione Europea (per un'elencazione dettagliata degli atti si fa rinvio all’elenco contenuto nell’allegato al decreto legislativo n. 24/2023);</li>" +
                      "<li>illeciti relativi all'applicazione degli atti nazionali di attuazione degli atti dell'Unione Europea elencati nell’allegato alla Direttiva 2019/1937, in materia di: appalti pubblici; servizi, prodotti e mercati finanziari e prevenzione del riciclaggio e del finanziamento del terrorismo; sicurezza e conformità dei prodotti; sicurezza dei trasporti; tutela dell’ambiente; radioprotezione e sicurezza nucleare; sicurezza degli alimenti e dei mangimi e salute e benessere degli animali; salute pubblica; protezione dei consumatori; tutela della vita privata e protezione dei dati personali e sicurezza delle reti e dei sistemi informativi;</li>" +
                      "<li>atti od omissioni che ledono gli interessi finanziari dell'Unione Europea;</li>" +
                      '<li>atti od omissioni riguardanti il mercato interno (comprese le violazioni in materia di concorrenza e di aiuti di Stato e quelle in materia di imposta sulle società);</li>' +
                      '<li>atti o comportamenti che, pur non integrando un illecito, vanificano l’oggetto e le finalità delle leggi e dei regolamenti nazionali e dell’Unione Europea (per un’elencazione dettagliata degli atti si fa rinvio sempre all’elenco contenuto nell’allegato al decreto legislativo n. 24/2023), nonché di quelli a tutela degli interessi finanziari dell’Unione Europea e che regolano il mercato interno;</li>' +
                      '<li>illeciti amministrativi, contabili, civili o penali che non rientrano in quelli contemplati dai punti precedenti;</li>' +
                      '<li>condotte illecite ai sensi del D. Lgs. n. 231/2001 o violazioni dei modelli di organizzazione, gestione e controllo adottati ai sensi dello stesso.</li>' +
                      '</ol>'
                  },
                  {
                    p: (chunks) => <p>{chunks}</p>,
                    ol: (chunks) => <ol className="ordered-roman">{chunks}</ol>,
                    li: (chunks) => <li>{chunks}</li>
                  }
                )}
              </Accordion>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-4">
              <Accordion
                head={intl.formatMessage({
                  defaultMessage: 'Come posso fare la mia segnalazione?'
                })}
                Icon={open.thirdAccordion ? CROSS : PLUS}
                iconColor="#1576b0"
                open={open.thirdAccordion}
                setOpen={(state) => setOpen({ ...open, thirdAccordion: state })}
              >
                <div>
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        '<p>La segnalazione può essere effettuata in forma scritta oppure in forma orale, come di seguito indicato.</p>' +
                        '<p><b>Segnalazione scritta:</b></p>' +
                        '<p>I fornitori potranno contattare, autonomamente, la casella <a1>IBM.Ombudsman@ibm.com</a1> (reperibile sul sito internet <a2>IBM Global Procurement Ombudsman</a2>). Tutti gli altri segnalanti potranno inoltrare la loro segnalazione tramite posta elettronica al seguente indirizzo e-mail <a3><strong><em>Confidentially-Speaking@sistinf.it</em></strong></a3> compilando il seguente <strong><em>Form</em></strong> in ogni sua parte al fine di garantire la corretta gestione della stessa.</p>'
                    },
                    {
                      p: (chunks) => <p>{chunks}</p>,
                      b: (chunks) => <b>{chunks}</b>,
                      strong: (chunks) => <strong>{chunks}</strong>,
                      em: (chunks) => <em>{chunks}</em>,
                      a1: (chunks) => <a href="mailto:IBM.Ombudsman@ibm.com">{chunks}</a>,
                      a2: (chunks) => (
                        <a
                          href="https://www.ibm.com/procurement/ombudsman-information"
                          target="_blank"
                        >
                          {chunks}
                        </a>
                      ),
                      a3: (chunks) => (
                        <a href="mailto:Confidentially-Speaking@sistinf.it">{chunks}</a>
                      )
                    }
                  )}
                </div>
                <div className="mb-3">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="/assets/Confidentially_Speaking_Whistleblowing_SUBMISSION_FORM 2023.docx"
                  >
                    <button
                      type="button"
                      className="btn rounded-0 text-white text-uppercase snf-bg-color-denim snf-font-14 snf-font-md-17 snf-font-w6 px-3"
                    >
                      <FormattedMessage
                        defaultMessage="Scarica il modulo compilabile"
                        description="Download Segnalazioni - Scarica il modulo compilabile button label"
                      />
                    </button>
                  </a>
                </div>
                <div>
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        '<p>Il Form dovrà essere crittografato e sarà necessario inviare due e-mail separate: la prima contenente il Form crittografato e la seconda solo con la password (senza alcun allegato).</p>' +
                        '<p><u>Istruzioni di protezione per Windows</u>:</p>' +
                        '<p>a)	aprire il documento di Office che si desidera proteggere;</p>' +
                        '<p>b)	fare clic sul menu <b>File</b>, selezionare la scheda <b>Informazioni</b>, quindi selezionare il pulsante <b>Proteggi documento;</b></p>' +
                        '<p>c)	fare clic su <b>Crittografa con password;</b></p>' +
                        '<p>d)	immettere la password due volte, quindi fare clic su <b>OK</b>;</p>' +
                        '<p>e)	Attenzione! <u>La password deve essere inviata con un’altra e-mail</u>.</p>' +
                        '<p><u>Istruzioni di protezione per Mac</u>:</p>' +
                        '<p>a)	aprire il documento di Office che si desidera proteggere;</p>' +
                        '<p>b)	aprire il menu <b>Revisione</b>;</p>' +
                        '<p>c)	fare clic su <b>Proteggi documento</b>;</p>' +
                        '<p>d)	immettere la passphrase desiderata due volte, nel campo <b>Password</b>, quindi fare clic su <b>OK</b>.</p>' +
                        '<p>f)	Attenzione! <u>La password deve essere inviata con un’altra e-mail</u>.</p>'
                    },
                    {
                      p: (chunks) => <p>{chunks}</p>,
                      b: (chunks) => <b>{chunks}</b>,
                      u: (chunks) => <u>{chunks}</u>
                    }
                  )}
                </div>
                <div>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        'Il Form può essere consegnato anche in modalità posta ordinaria oppure consegnato a mano al seguente indirizzo:'
                    })}
                  </p>
                  <p className="mb-0 snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: 'Sistemi Informativi Srl'
                    })}
                  </p>
                  <p className="mb-0 snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: 'Via Luigi Stipa, 150'
                    })}
                  </p>
                  <p className="snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: '00148 Roma (RM)'
                    })}
                  </p>
                  <p>
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'alla cortese attenzione: <i>Gestore delle segnalazioni del Programma Confidentially Speaking - Whistleblowing</i>'
                      },
                      {
                        i: (chunks) => <i>{chunks}</i>
                      }
                    )}
                  </p>
                </div>
                <div>
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        '<p>La segnalazione deve essere inserita in due buste chiuse, includendo:</p>' +
                        '<p>a)nella prima, i dati identificativi del segnalante, unitamente a un documento di identità;</p>' +
                        '<p>b)nella seconda, l’oggetto della segnalazione.</p>' +
                        '<p>Entrambe le buste dovranno, poi, essere inserite in una terza busta riportando, all’esterno, la dicitura <i>’Riservata al Gestore delle segnalazioni’</i>.</p>'
                    },
                    {
                      p: (chunks) => <p>{chunks}</p>,
                      i: (chunks) => <i>{chunks}</i>
                    }
                  )}
                </div>
                <div>
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        '<p><b>Segnalazione orale:</b></p>' +
                        '<p>Se preferisci, potrai anche chiedere al Gestore delle segnalazioni – sempre tramite posta elettronica al seguente indirizzo e-mail <a>Confidentially-Speaking@sistinf.it</a>, oppure via telefono al numero indicato, di essere sentito personalmente per l’effettuazione della segnalazione orale.</p>' +
                        '<p>A tal fine, è messo a disposizione il seguente numero telefonico: <i><b>+39 347 7954718</b></i></p>' +
                        '<p>Previo consenso della persona segnalante, le segnalazioni orali possono essere documentate e trascritte.</p>'
                    },
                    {
                      p: (chunks) => <p>{chunks}</p>,
                      i: (chunks) => <i>{chunks}</i>,
                      b: (chunks) => <b>{chunks}</b>,
                      a: (chunks) => (
                        <a href="mailto:Confidentially-Speaking@sistinf.it">{chunks}</a>
                      )
                    }
                  )}
                </div>
              </Accordion>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-4">
              <Accordion
                head={intl.formatMessage({
                  defaultMessage: 'La mia segnalazione rimarrà confidenziale?'
                })}
                Icon={open.fourthAccordion ? CROSS : PLUS}
                iconColor="#1576b0"
                open={open.fourthAccordion}
                setOpen={(state) => setOpen({ ...open, fourthAccordion: state })}
              >
                <p>
                  {intl.formatMessage({
                    defaultMessage:
                      'La tua segnalazione rimarrà strettamente confidenziale e conosciuta unicamente dal Gestore delle segnalazioni e dalle persone che dovranno necessariamente essere coinvolte per investigare sulla segnalazione stessa.'
                  })}
                </p>
              </Accordion>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-4">
              <Accordion
                head={intl.formatMessage({
                  defaultMessage: 'Posso effettuare la mia segnalazione in forma del tutto anonima?'
                })}
                Icon={open.fifthAccordion ? CROSS : PLUS}
                iconColor="#1576b0"
                open={open.fifthAccordion}
                setOpen={(state) => setOpen({ ...open, fifthAccordion: state })}
              >
                <div>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        'Se preferisci effettuare la tua segnalazione in modalità totalmente anonima, potrai trasmetterla per tramite di un indirizzo e-mail che non contenga alcun riferimento alla tua identità. In questo caso, non potrai essere ricontattato tramite tale indirizzo e-mail per discutere della segnalazione e fornire eventuali ulteriori chiarimenti.'
                    })}
                  </p>
                </div>
                <div>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        'In alternativa, la tua eventuale segnalazione in forma anonima potrà essere inviata al Gestore delle segnalazioni in forma cartacea tramite posta al seguente indirizzo:'
                    })}
                  </p>
                  <p className="mb-0 snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: 'Sistemi Informativi Srl'
                    })}
                  </p>
                  <p className="mb-0 snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: 'Via Luigi Stipa, 150'
                    })}
                  </p>
                  <p className="snf-font-w6">
                    {intl.formatMessage({
                      defaultMessage: '00148 Roma (RM)'
                    })}
                  </p>
                  <p>
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'alla cortese attenzione: <i>Gestore delle segnalazioni del Programma Confidentially Speaking - Whistleblowing</i>'
                      },
                      {
                        i: (chunks) => <i>{chunks}</i>
                      }
                    )}
                  </p>
                </div>
              </Accordion>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-4">
              <Accordion
                head={intl.formatMessage({
                  defaultMessage: 'Come sarà gestita la mia segnalazione?'
                })}
                Icon={open.sixthAccordion ? CROSS : PLUS}
                iconColor="#1576b0"
                open={open.sixthAccordion}
                setOpen={(state) => setOpen({ ...open, sixthAccordion: state })}
              >
                <div>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        'Una volta inviata la tua segnalazione secondo una delle modalità sopra descritte:'
                    })}
                  </p>
                  {intl.formatMessage(
                    {
                      defaultMessage:
                        '<ol>' +
                        '<li>entro 7 giorni dalla data di ricevimento della tua segnalazione, riceverai un avviso di ricevimento;</li>' +
                        '<li>potresti essere contattato da un "investigatore" interno al fine di avere maggiori dettagli e/o chiarimenti in merito alla segnalazione. Il colloquio potrà avvenire di persona o per telefono;</li>' +
                        '<li>entro 3 mesi dalla data dell’avviso di ricevimento della tua segnalazione, riceverai un riscontro in merito alla segnalazione stessa.</li>' +
                        '</ol>'
                    },
                    {
                      p: (chunks) => <p>{chunks}</p>,
                      ol: (chunks) => <ol className="ordered-alphabetic">{chunks}</ol>,
                      li: (chunks) => <li>{chunks}</li>
                    }
                  )}
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        'Nel caso tu optassi per la segnalazione in forma anonima, non essendo nota la tua identità, non sarà possibile al Gestore delle segnalazioni richiederti maggiori dettagli e/o chiarimenti, né fornirti un feedback in merito alla segnalazione stessa. L’impossibilità di contattarti per eventuali ulteriori chiarimenti potrebbe avere un impatto sulla prosecuzione delle indagini. In tal caso, la nostra indagine si baserà esclusivamente sulle informazioni che ci hai condiviso: è perciò importante che tu fornisca informazioni sufficienti per garantirci la possibilità di dare seguito alle necessarie verifiche interne.'
                    })}
                  </p>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        "Considerando la materia oggetto delle segnalazioni, l'identità del segnalante rimarrà strettamente confidenziale e conosciuta unicamente dal Gestore delle segnalazioni e dalle direzioni che dovranno necessariamente essere coinvolte - ai fini legali - per investigare sulla segnalazione stessa."
                    })}
                  </p>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        "Al fine di garantire l'integrità del programma, l'identità del segnalante (o informazioni da cui possa evincersi) che ha fatto la segnalazione, non verrà fornita dal Gestore delle segnalazioni a persone diverse da quelle competenti e autorizzate dalla legge senza sua specifica autorizzazione."
                    })}
                  </p>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        'Le attività connesse alla gestione delle segnalazioni in ambito whistleblowing, inclusa la comunicazione tra autorità competenti, implicano il trattamento di dati personali di vari soggetti interessati: il segnalante, la persona coinvolta e i terzi menzionati nella segnalazione, ad esempio testimoni o colleghi. Anzitutto, in applicazione del principio di minimizzazione, i dati personali che manifestamente non sono utili al trattamento di una specifica segnalazione non devono essere indicati e, se ricevuti o accidentalmente raccolti, andranno immediatamente cancellati.'
                    })}
                  </p>
                  <p>
                    {intl.formatMessage({
                      defaultMessage:
                        'Ulteriori dettagli riguardo il trattamento dei tuoi dati personali in occasione dell’utilizzo del canale, sono disponibili al seguente '
                    })}{' '}
                    <a
                      onClick={() => {
                        setOpenModal(true);
                      }}
                      className="text-decoration-underline snf-color-anchor-blue"
                      tabIndex="0"
                      role="button"
                      onKeyDown={(event) => {
                        switch (event.keyCode) {
                          case keyCodes.ENTER: {
                            setOpenModal(true);
                            break;
                          }
                          default:
                            break;
                        }
                      }}
                    >
                      link.
                    </a>
                  </p>
                  <ModalDatiPersonali
                    open={openModal}
                    onClose={() => {
                      setOpenModal(false);
                    }}
                  />
                </div>
              </Accordion>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-4">
              <Accordion
                head={intl.formatMessage({
                  defaultMessage: 'Il nostro processo'
                })}
                Icon={open.seventhAccordion ? CROSS : PLUS}
                iconColor="#1576b0"
                open={open.seventhAccordion}
                setOpen={(state) => setOpen({ ...open, seventhAccordion: state })}
              >
                <p>
                  {intl.formatMessage({
                    defaultMessage:
                      "Procedura per la gestione delle segnalazioni di condotte illecite alla luce dell'entrata in vigore del Decreto Legislativo 10 marzo 2023, n. 24"
                  })}
                </p>
                <div className="mb-3">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="/assets/Segnalazione di condotte illecite – Whistleblowing_v8.pdf"
                  >
                    <button
                      type="button"
                      className="btn rounded-0 text-white text-uppercase snf-bg-color-denim snf-font-14 snf-font-md-17 snf-font-w6 px-3"
                    >
                      <FormattedMessage
                        defaultMessage="Segnalazione di condotte illecite - Whistleblowing"
                        description="Segnalazione di condotte illecite - Whistleblowing- Scarica il modulo compilabile button label"
                      />
                    </button>
                  </a>
                </div>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
